import React, { useMemo, useRef } from "react"
import GridContainer from "@/components/common/GridContainer"
import CommonImage from "@/components/common/Image"
import HeaderDescription from "@/components/common/Header&Description"
import styled from "styled-components"
import { gsap, ScrollTrigger, useGSAP } from "@/utils/gsap"
import useIsDebug from "@/hooks/useIsDebug"
import { getPaddingsClassFromData } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { useIsDesktop } from "@/hooks/useDevice"

const VARIANTS = {
	STATIC: "static",
	DYNAMIC: "dynamic",
}

const Wrapper = styled(GridContainer)`
	justify-content: center;
	overflow: hidden;
	position: relative;
	row-gap: 30px;
`

const Image = styled(CommonImage)`
	aspect-ratio: 9/11;

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		//aspect-ratio: 9/16;
		&.${VARIANTS.STATIC} {
			clip-path: inset(0);

			img {
				transform: translateY(-125svh);
			}
		}
	}
`

const StyledHeaderDescription = styled(HeaderDescription)`
	height: fit-content;
	align-self: center;
`

const ParallaxImageAndDescription = ({ data }) => {
	const WrapperRef = useRef()
	const ImageRef = useRef()
	const variant = useMemo(() => data?.variant || VARIANTS.DYNAMIC, [data])
	// const variant =  VARIANTS.DYNAMIC
	const image = data?.image?.image || {}
	const headerDescription = data?.headerDescription || {}
	const paddings = getPaddingsClassFromData(data)
	const debug = useIsDebug()
	const isDesktop = useIsDesktop()

	useGSAP(
		() => {
			if (!isDesktop) return

			if (variant === VARIANTS.DYNAMIC) {
				const PARALLAX_POWER = 20 //percentage of image height
				gsap.timeline({
					scrollTrigger: {
						trigger: WrapperRef.current,
						markers: debug,
						invalidateOnRefresh: true,
						scrub: 0.75,
					},
				}).fromTo(
					ImageRef.current.children[0],
					{
						yPercent: -PARALLAX_POWER,
						ease: "none",
					},
					{
						yPercent: PARALLAX_POWER,
						ease: "none",
					},
				)
			} else {
				ScrollTrigger.create({
					trigger: WrapperRef.current,
					start: "top bottom",
					pin: ImageRef.current.children[0],
					invalidateOnRefresh: true,
				})
			}
		},
		{
			dependencies: [debug, variant, isDesktop],
			revertOnUpdate: true,
			scope: WrapperRef.current,
		},
	)

	return (
		<Wrapper ref={WrapperRef} className={`${paddings}`}>
			<Image
				ref={ImageRef}
				src={image.url}
				alt={image.alt || "ParallaxImageAndDescription Image"}
				focalPoint={image.focalPoint}
				placeholder={image.blurUpThumb}
				className={`col-mobile-8 col-tablet-4 col-desktop-10 ${variant}`}
			/>
			<StyledHeaderDescription data={headerDescription} className={`col-mobile-8 col-tablet-4 col-desktop-6`} />
		</Wrapper>
	)
}

export default ParallaxImageAndDescription
